/** Map DB reels rows to the UI shape used by Academia / AdminQueue */
export function mapReelFromDb(row) {
  if (!row) return null;
  return {
    ...row,
    thumbnail_url: row.embed_url,
    linked_training_id: row.training_id,
    member_id: row.submitted_by,
  };
}

export function mapTrainingFromDb(row) {
  if (!row) return null;
  return { ...row };
}
